// extracted by mini-css-extract-plugin
module.exports = {"container":"_-_-pharmacy-src-question-questionRequestModal-formScreen__container--3EHth","subtitle":"_-_-pharmacy-src-question-questionRequestModal-formScreen__subtitle--1NhJX"};